<template>
  <div id="information">
    <headTop @logout="logoutClick"></headTop>
    <section class="container">
      <div class="title">
        <div>完善信息</div>
        <div @click="goBack">> 返回</div>
      </div>

      <div class="infor">
        <div class="adress">
          <div class="f3">截止日期</div>
          <div class="f7" @click="selectEndTime" @touchmove.prevent>
            <input
              type="text"
              placeholder="截止日期必须大于当前日期"
              readonly
              οnfοcus="this.blur()"
              v-model="endtime"
              disabled
            />
            <div></div>
          </div>
        </div>
        <div class="adress">
          <div class="f3">期望收货日期</div>
          <div class="f7" @click="selectstartTime" @touchmove.prevent>
            <input
              type="text"
              placeholder="期望收货日期必须大于截止日期"
              v-model="starttime"
              readonly
              οnfοcus="this.blur()"
            />
            <div></div>
          </div>
        </div>
        <div class="adress">
          <div class="f3">交货地点</div>
          <div class="f7" @click="selectAdress" @touchmove.prevent>
            <input type="text" placeholder="请选择" readonly οnfοcus="this.blur()" v-model="adress" />
            <div></div>
          </div>
        </div>
        <div class="end">
          <mt-datetime-picker
            ref="end"
            type="date"
            year-format="{value}年"
            month-format="{value}月"
            date-format="{value}日"
            :startDate="start"
            @confirm="handleConfirm"
          ></mt-datetime-picker>
        </div>
        <div class="start">
          <mt-datetime-picker
            ref="start"
            type="date"
            year-format="{value}年"
            month-format="{value}月"
            date-format="{value}日"
            :startDate="start"
            @confirm="startTime"
          ></mt-datetime-picker>
        </div>

        <AdressList v-show="showList" @addressList="getAdress"></AdressList>
      </div>
    </section>
    <div id="bottom-button">
      <div class="wrapper">
        <div class="inactive button" :class="{'active':active}" @click="submit">提交</div>
      </div>
    </div>

    <div class="modal" v-show="showSuccess">
      <div class="modal_box">
        <div class="success">
          <div class="success_img">
            <img src="../assets/success.png" alt />
          </div>
          <h3>提交成功</h3>
          <p>此需求已发布成功，</p>
          <p>后续会有供应商与您联系</p>
          <p class="call">如有疑问请拨打客服热线</p>
          <p class="phone">400-1919-119</p>
        </div>
        <div class="close" @click="closeModal">
          <img src="../assets/close.png" alt />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import headTop from './header'
import AdressList from '../components/adress_list'
import { _throttle } from '../utils/public'

export default {
  name: 'information',
  components: { headTop, AdressList },
  data () {
    return {
      showList: false, // 展示地址列表
      adress: '',
      province: '',
      city: '',
      district: '',
      endtime: '',
      showEndTime: false,
      starttime: '',
      showSuccess: false,
      cookieArr: [],
      start: new Date()
    }
  },
  created () {
    let shop = localStorage.getItem('shop')
    this.cookieArr = JSON.parse(shop)
  },
  computed: {
    active () {
      if (this.starttime !== '' && this.endtime !== '' && this.province !== '' && this.city !== '' && this.district) {
        return true
      } else {
        return false
      }
    }
  },
  methods: {
    selectAdress () { // 选择地址
      this.showList = true
    },
    getAdress (bool, province, city, district) {
      this.showList = bool
      if (province !== '') {
        this.province = province
        this.city = city
        this.district = district
        this.adress = `${province} ${city} ${district}`
      }
    },
    selectEndTime () {
      this.$refs.end.open()
    },
    submit: _throttle(function () {
      if (this.active) {
        var date = new Date().getTime()
        // 判断是否选择截止时间
        if (this.endtime === '') {
          this.$Message.warning({
            content: '请选择截止日期',
            duration: 1.5
          })
          return false
        }

        // 判断是否选择期望收货时间
        if (this.starttime === '') {
          this.$Message.warning({
            content: '请选择截止日期',
            duration: 1.5
          })
          return false
        }
        let end = new Date(this.endtime).getTime()
        if (end < date) {
          this.$Message.warning({
            content: '截止日期必须大于当前日期',
            duration: 1.5
          })
          return false
        }

        let start = new Date(this.starttime).getTime()
        if (start < date) {
          this.$Message.warning({
            content: '收货日期必须大于当前日期',
            duration: 1.5
          })
          return false
        }
        if (start < end) {
          this.$Message.warning({
            content: '期望收货日期必须大于截止日期',
            duration: 1.5
          })
          return false
        }

        let ids = this.$route.query.ids

        let dataform = {
          province: this.province,
          city: this.city,
          area: this.district,
          ids: ids,
          region_id: '',
          excepted_receving_date: this.endtime,
          expiration_date: this.starttime,
          is_contains_eval: 1
        }
        var _this = this
        this.utils.POSTHeader(this.companyUrl + '/shoppingCart/releaseWantBuy', {
          'Content-Type': 'application/json',
          'Cache-control': 'no-cache',
          'Pragma': 'no-cache',
          'Expires': 0,
          'zxzxkey': ''
        }, dataform, (response) => {
          if (response.success === true) {
            _this.showSuccess = true
            let ids = this.$route.query.ids.split(',')
            for (let id of ids) {
              for (let item of this.cookieArr) {
                if (item.id === Number(id)) {
                  let inx = this.cookieArr.indexOf(item)
                  this.cookieArr.splice(inx, 1)
                }
              }
            }
            console.log(this.cookieArr)

            localStorage.setItem('shop', JSON.stringify(this.cookieArr))
//          let resaultid = localStorage.getItem('resultId')
//          this.$router.replace({path: '/fxcp_result',query: {resultId: resaultid}})

            // if (this.cookieArr.length > 0) {
            //   this.showSuccess = true
            //   // this.$router.push('/purchasing')
            // } else {
            //   this.$router.replace('/')
            // }
          }
        })
      }
    }, 4000),
    handleConfirm (e) {
      let year = e.getFullYear()
      let month = e.getMonth() + 1
      let days = e.getDate()
      month = month > 9 ? month : '0' + month
      days = days > 9 ? days : '0' + days
      this.endtime = `${year}-${month}-${days}`
    },
    startTime (e) {
      let year = e.getFullYear()
      let month = e.getMonth() + 1
      let days = e.getDate()
      month = month > 9 ? month : '0' + month
      days = days > 9 ? days : '0' + days
      this.starttime = `${year}-${month}-${days}`
    },

    selectstartTime () {
      this.$refs.start.open()
    },
    goBack () {
      this.$router.push('/purchasing')
    },
    closeModal () {
     this.showSuccess = false
//    this.$router.push('/purchasing')
      let resaultid = localStorage.getItem('resultId')
      this.$router.replace({path: '/fxcp_result',query: {resultId: resaultid}})
    },
    setCookie () {
      let shop = localStorage.getItem('shop')
      this.cookieArr = JSON.parse(shop)
      let ids = this.$route.query.isd.split(',')
      for (let id of ids) {
        for (let item of this.cookieArr) {
          if (item.id === id) {
            let inx = this.cookieArr.indexOf(item)
            this.cookieArr.splice(inx, 1)
          }
        }
      }
      localStorage.setItem('shop', JSON.stringify(this.cookieArr))

      if (this.cookieArr.length > 0) {
        this.$router.push('/purchasing')
      } else {
        this.$router.replace('/')
      }
    },
    logoutClick () { // 退出登录
      this.$router.replace('home')
    }
  }

}
</script>
<style lang="scss" scoped>
#information {
  * {
    padding: 0;
    margin: 0;
  }
  body {
    background: #f4f4f4;
    font-family: 'Helvetica Neue', Helvetica, 'PingFang SC', 'Hiragino Sans GB',
      'Microsoft YaHei', '\5FAE\8F6F\96C5\9ED1', Arial, sans-serif;
  }
  // 模态框
  .modal {
    width: 100%;
    height: 100%;
    position: absolute;
    background: rgba(0, 0, 0, 0.5);
    top: 0;
    left: 0;
    z-index: 1000;
    .modal_box {
      width: 80%;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);

      .success {
        width: 100%;
        background: #fff;
        padding: 30px;
        .success_img {
          width: 100%;
          height: 50px;
          img {
            width: 50px;
            height: 50px;
            display: block;
            margin: auto;
          }
        }
        h3 {
          height: 48px;
          font-size: 18px;
          font-family: SourceHanSansCN-Bold;
          font-weight: bold;
          color: rgba(75, 174, 79, 1);
          line-height: 48px;
          text-align: center;
        }
        p {
          text-align: center;
          height: 20px;
          line-height: 20px;
          font-size: 14px;
          color: #000000;
        }
        .call {
          color: #808080;
          margin-top: 15px;
        }
        .phone {
          color: #c41335;
          font-size: 14px;
          margin-top: 8px;
        }
      }
      .close {
        width: 100%;
        height: 28px;
        margin: 15px auto 0;
        img {
          width: 28px;
          height: 28px;
          display: block;
          margin: 0 auto;
        }
      }
    }
  }

  .container {
    background: #f4f4f4;
    .title {
      height: 50px;
      width: 100%;
      padding: 0 15px;
      background: #fff;
      div:first-child {
        float: left;
        height: 50px;
        line-height: 50px;
        font-size: 15px;
        font-weight: 700;
        color: #000;
      }
      div:last-child {
        float: right;
        height: 50px;
        line-height: 50px;
        font-size: 12px;
        color: #808080;
      }
    }
    .infor {
      width: 100%;
      margin-top: 10px;
      padding: 0 15px;
      background: #fff;

      .adress {
        height: 50px;
        border-bottom: 1px solid #f4f4f4;
        display: flex;
        display: -webkit-flex;
        .f3 {
          flex: 3;
          -webkit-flex: 3;
          line-height: 50px;
          font-size: 14px;
          color: #000;
        }
        .f7 {
          flex: 7;
          -webkit-flex: 7;
          height: 30px;
          line-height: 30px;
          margin-top: 10px;
          position: relative;
          input {
            height: 30px;
            width: 100%;
            border: none;
            outline: none;
            font-size: 14px;
            color: #000;
          }
          input:disabled {
            color: #000;
            -webkit-text-fill-color: #000;
            -webkit-opacity: 1;
            opacity: 1;
          }

          input::placeholder {
            font-size: 14px;
            color: #bebebe;
            -webkit-text-fill-color: #bebebe;
          }
          input::-webkit-input-placeholder {
            font-size: 14px;
            color: #bebebe;
            -webkit-text-fill-color: #bebebe;
          }
          input::input-placeholder {
            font-size: 14px;
            color: #bebebe;
            -webkit-text-fill-color: #bebebe;
          }
          div {
            position: absolute;
            top: -10px;
            right: 5px;
            width: 30px;
            height: 50px;
            background: url('../assets/arrow.png') no-repeat center center;
            background-size: 15px 15px;
            margin: 0;
          }
        }
      }
    }
  }
  .wrapper {
    position: fixed;
    width: 100%;
    bottom: 0px;
    height: 65px;
    background-color: #ffffff;
    border-top: solid #eeeeee 1px;
    box-sizing: border-box;
    z-index: 100;
  }
  .wrapper .button {
    position: absolute;
    left: 15px;
    right: 15px;
    top: 10px;
    height: 45px;
    line-height: 45px;
    text-align: center;
    font-size: 15px;
    color: #ffffff;
    border-radius: 3px;
  }
  .inactive {
    background-color: #fe9797;
  }
  .active {
    background-color: #c41335;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/modify_information.vue